module.exports = __webpack_public_path__ + "img/mf.532e1d90.svg";